import { useEffect } from 'react';

const useEffectOnce = (effect) => {
  useEffect(effect, []);
};

export { useEffectOnce as default };
//# sourceMappingURL=useEffectOnce.mjs.map
